module.exports = __webpack_public_path__ + "img/多边形-暗.83616d0b.png";